import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { apiGetOneProffitSearchInformation } from '../../../../actions/ProffitSearchAction';
import { AllLoaderComponent } from '../../Loading';
const ProffitSearchInformationHoc = (setting) => (ChildComponent) => {
    const { needLoading = true, skeleton } = setting || {};
    const ProffitSearchInformationHocInner = (props) => {
        const dispatch = useDispatch();
        const proffitSearch = useSelector((state) => state.proffitSearch);
        useEffect(() => {
            dispatch(apiGetOneProffitSearchInformation());
        }, [dispatch]);
        const isLoading = useMemo(() => !!((!proffitSearch || Object.keys(proffitSearch).length === 0) &&
            needLoading), [proffitSearch]);
        if (isLoading) {
            return skeleton || _jsx(AllLoaderComponent, {});
        }
        return _jsx(ChildComponent, Object.assign({}, props, { proffitSearch: proffitSearch }));
    };
    ProffitSearchInformationHocInner.propTypes = {};
    return ProffitSearchInformationHocInner;
};
export default ProffitSearchInformationHoc;
